import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const LinkTop = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="LinkTop" {...props}>
    <path d="M11.3691 4.22461C11.7619 3.90426 12.3409 3.92685 12.707 4.29297L19.707 11.293C20.0976 11.6835 20.0976 12.3165 19.707 12.707C19.3165 13.0976 18.6835 13.0976 18.293 12.707L13 7.41406V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V7.41406L5.70703 12.707C5.31651 13.0976 4.68349 13.0976 4.29297 12.707C3.90244 12.3165 3.90244 11.6835 4.29297 11.293L11.293 4.29297L11.3691 4.22461Z" fill="#000" /><path d="M22 1C22.5523 1 23 1.44772 23 2C23 2.55228 22.5523 3 22 3H2C1.44772 3 1 2.55228 1 2C1 1.44772 1.44772 1 2 1H22Z" fill="#000" />
  </StyledIcon>
));

LinkTop.displayName = 'LinkTop';

export { LinkTop };
